import { User, MapPin, Mail } from "lucide-react";

const teamMembers = [
  { name: "varahi", position: "Campaigner", location: "Hyderabad" },
  { name: "Michael", position: "Beneficiary", location: "Daughter" },
];

const TeamMembersCard = () => {
  return (
    <div className="bg-white p-6">
      <div className="flex items-center justify-between mb-5">
        <h3 className="text-lg font-heading font-semibold text-foreground">
          Team Members
        </h3>
      </div>

      <div className="space-y-4">
        {teamMembers.map((member, index) => (
          <div
            key={index}
            className="relative flex items-start gap-4 p-4 rounded-lg bg-white transition-colors"
          >
            <div className="w-12 h-12 rounded-full bg-gradient-to-br  to-accent flex items-center justify-center flex-shrink-0">
              <User size={24} className="text-primary-foreground" />
            </div>

            <div className="flex-1 min-w-0">
              <h4 className="font-semibold text-foreground">{member.name}</h4>
              <p className="text-sm text-primary">{member.position}</p>
              <div className="flex items-center gap-1 mt-1 text-xs text-muted-foreground">
                <MapPin size={12} />
                <span>{member.location}</span>
              </div>
            </div>

            {/* Replacing custom Button with plain JSX button */}
            <button
              className="absolute top-4 right-4 flex items-center gap-1 px-2 py-1 border border-teal-500 text-teal-500 rounded-md text-sm hover:bg-teal-500 hover:text-white transition"
            >
              <Mail size={14} />
              Contact
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TeamMembersCard;
